<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { LoaderIcon } from '@solar-icons/vue/linear'

const props = withDefaults(
  defineProps<{
    /** Announced to assistive tech; the spinner shows no visible text. */
    label?: string
    size?: 'sm' | 'md' | 'lg'
    /** Ink: `muted` (default) · `current`, which inherits the parent's colour. */
    tone?: 'muted' | 'current'
  }>(),
  {
    label: undefined,
    size: 'md',
    tone: 'muted',
  },
)

const { t } = useI18n()

const SIZE_CLASSES: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'size-6',
  md: 'size-8',
  lg: 'size-12',
}

const resolvedLabel = computed(() => props.label ?? t('primitives.loading'))
const sizeClass = computed(() => SIZE_CLASSES[props.size])
const toneClass = computed(() => (props.tone === 'current' ? 'text-current' : 'text-icon-tertiary'))
</script>

<template>
  <span class="inline-flex">
    <LoaderIcon
      role="status"
      :aria-label="resolvedLabel"
      :class="['motion-safe:animate-spin', toneClass, sizeClass]"
    />
    <span class="sr-only">{{ resolvedLabel }}</span>
  </span>
</template>
